/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';

import BudgetService from '@/services/api/budget';
import BudgetLogs from '@/services/api/budgetLogs';

const getDefaultState = () => ({
  loading: false,
  loading_vehicle: false,
  loading_media: false,
  id: null,
  number: null,
  created_at: null,
  created_by_user: null,
  description: null,
  observation: null,
  hash: null,
  service_order_type: null,
  status: null,
  client: null,
  vehicle: null,
  service_order_logs: null,
  forecast_date: null,
  responsibles: [],
  service: {},
  service_order_checklists: [],
  service_order_photos: [],
  service_order_photo_sections: [],
  service_order_evaluations: [],
  checklist_warning: false,
  service_order_signatures: [],
  service_order_brings: [],
  service_order_attachments: [],
  service_order_audios: [],
  budgets: [],
  wheel_torque: null,
  score: { emoji: '😃', minimum: 0, color: '#c9c9c9', score: 0 },
  description_loading: false
});

const state = getDefaultState();

const getters = {
  id(state) {
    return state.id;
  },
  hash(state) {
    return state.hash;
  },
  isLoading(state) {
    return state.loading;
  },
  isVehicleLoading(state) {
    return state.loading_vehicle;
  },
  isMediaLoading(state) {
    return state.loading_media;
  },
  intialDetails(state) {
    return state;
  },
  client(state) {
    return state.client;
  },
  client_name(state) {
    return state.client && state.client !== null ? state.client.name : 'Cliente não especificado';
  },
  vehicle(state) {
    return state.vehicle;
  },
  service(state) {
    return state.service;
  },
  status(state) {
    return state.status;
  },
  logs(state) {
    return state.service_order_logs;
  },
  forecast_date(state) {
    return state.forecast_date;
  },
  description(state) {
    return state.description;
  },
  responsibles(state) {
    return state.responsibles;
  },
  created_by_user(state) {
    return state.created_by_user;
  },
  checklists(state) {
    return state.service_order_checklists;
  },
  checklist_warning(state) {
    return state.checklist_warning;
  },
  evaluation(state) {
    return state.service_order_evaluations ? state.service_order_evaluations[0] : null;
  },
  service_order_signatures(state) {
    return state.service_order_signatures;
  },
  service_order_bring(state) {
    return state.service_order_brings && state.service_order_brings.length > 0 ? state.service_order_brings[0] : 0;
  },
  service_order_attachments(state) {
    return state.service_order_attachments;
  },
  service_order_audios(state) {
    return state.service_order_audios;
  },
  service_order_bring_id(state) {
    return state.service_order_brings && state.service_order_brings.length > 0 ? state.service_order_brings[0].id : null;
  },
  wheel_torque(state) {
    return state.wheel_torque;
  },
  score(state) {
    return state.score;
  },
  update_list(state) {
    return state;
  },
  description_loading(state) {
    return state.description_loading;
  }
};

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_VEHICLE_LOADING(state, status) {
    state.loading_vehicle = status;
  },
  SET_MEDIA_LOADING(state, status) {
    state.loading_media = status;
  },
  SET_DESCRIPTION_LOADING(state, status) {
    state.description_loading = status;
  },
  SET_SCORE(state, newScore) {
    state.score = newScore;
  },
  SET_UPDATED_SERVICE_ORDER(state, serviceOrder) {
    state.number = serviceOrder.number;
    state.service_order_type = serviceOrder.type;
  },
  SET_SERVICE_ORDER(state, serviceOrder) {
    state.id = serviceOrder.id;
    state.number = serviceOrder.number;
    state.created_at = serviceOrder.created_at;
    state.created_by_user = serviceOrder.created_by_user;
    state.hash = serviceOrder.hash;
    state.service_order_type = serviceOrder.service_order_type;
    state.status = serviceOrder.status;
    state.service_order_logs = serviceOrder.service_order_logs;
    state.active = serviceOrder.active;
    state.customer_review = serviceOrder.customer_review;
    state.description = serviceOrder.description;
    state.client = serviceOrder.client;
    state.finished_at = serviceOrder.finished_at;
    state.forecast_date = serviceOrder.forecast_date;
    state.organization_observation = serviceOrder.organization_observation;
    state.priority = serviceOrder.priority;
    state.service_order_photos = serviceOrder.service_order_photos ? serviceOrder.service_order_photos : [];
    state.service_order_photo_sections = serviceOrder.service_order_photo_sections ?? [];
    state.vehicle = serviceOrder.vehicle;
    state.vehicle_fuel = serviceOrder.vehicle_fuel;
    state.vehicle_kilometer = serviceOrder.vehicle_kilometer;
    state.responsibles = serviceOrder.service_order_responsibles ? serviceOrder.service_order_responsibles.map((r) => r.user) : [];
    state.service_order_checklists = serviceOrder.service_order_checklists
      ? serviceOrder.service_order_checklists.sort((a, b) => a.checklist.order - b.checklist.order)
      : [];
    state.service_order_evaluations = serviceOrder.service_order_evaluations;
    state.service_order_signatures = serviceOrder.service_order_signatures ? serviceOrder.service_order_signatures : [];
    state.service_order_brings = serviceOrder.service_order_brings;
    state.service_order_attachments = serviceOrder.service_order_attachments;
    state.service_order_audios = serviceOrder.service_order_audios;
    state.budgets = serviceOrder.budgets ?? [];
    state.wheel_torque = serviceOrder.service_order_wheel_torques;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_CLIENT(state, serviceOrderClient) {
    state.client = serviceOrderClient;
  },
  SET_VEHICLE(state, serviceOrderVehicle) {
    state.vehicle = serviceOrderVehicle;
  },
  REMOVE_VEHICLE(state) {
    state.vehicle = null;
  },
  SET_SERVICE_STATUS(state, serviceOrderServiceStatus) {
    state.status = serviceOrderServiceStatus.description;
    state.service_order_logs.push(serviceOrderServiceStatus);
  },
  SET_FORECAST_DATE(state, date) {
    state.forecast_date = date;
  },
  SET_CLIENT_DESCRIPTION(state, description) {
    state.description = description;
  },
  SET_ORGANIZATION_OBSERVATION(state, observation) {
    state.observation = observation;
  },
  SET_VEHICLE_KILOMETER(state, vehicleKilometer) {
    state.vehicle_kilometer = vehicleKilometer;
  },
  SET_RESPONSIBLE(state, responsibles) {
    state.responsibles = responsibles;
  },
  UPDATE_CHECKLIST_ITEM(state, { checklistIndex, counters }) {
    state.service_order_checklists[checklistIndex].checked_itens = counters.checked;
    state.service_order_checklists[checklistIndex].checked_itens_ok = counters.ok;
    state.service_order_checklists[checklistIndex].checked_itens_caution = counters.caution;
    state.service_order_checklists[checklistIndex].checked_itens_problem = counters.problem;
    state.service_order_checklists[checklistIndex].checked_itens_not_applicable = counters.not_applicable;
  },
  SET_CHECKLIST_WARNING(state, status) {
    state.checklist_warning = status;
  },
  ADD_SIGNATURE(state, serviceOrderSignature) {
    state.service_order_signatures.push(...serviceOrderSignature);
  },
  REMOVE_SIGNATURE(state, serviceOrderSignatureHash) {
    state.service_order_signatures = state.service_order_signatures.filter((sig) => sig.hash !== serviceOrderSignatureHash);
  },
  SET_SERVICE_ORDER_BRING(state, bring) {
    state.service_order_brings = [bring];
  },
  ADD_BUDGET(state, serviceOrderBudget) {
    const budgetIndex = state.budgets?.findIndex((b) => b.id === serviceOrderBudget?.id);

    if (budgetIndex === -1) {
      state.budgets.push(serviceOrderBudget);
    }
  },
  REMOVE_BUDGET(state, budgetId) {
    state.budgets = state.budgets.filter((b) => b.id !== budgetId);
  },
  SET_SERVICE_ORDER_WHEEL_TORQUE(state, wheelTorque) {
    if (wheelTorque === null) {
      state.wheel_torque = null;
    } else if (Array.isArray(wheelTorque)) {
      state.wheel_torque = wheelTorque;
    } else {
      state.wheel_torque = [wheelTorque];
    }
  },
  REMOVE_SERVICE_ORDER_PHOTO(state, mediaId) {
    state.service_order_photos = state.service_order_photos.filter((photo) => photo.id !== mediaId);
  },
  REMOVE_SERVICE_ORDER_AUDIO(state, mediaId) {
    state.service_order_audios = state.service_order_audios.filter((audio) => audio.id !== mediaId);
  },
  ADD_SERVICE_ORDER_PHOTO(state, media) {
    state.service_order_photos.push(media);
  },
  ADD_SERVICE_ORDER_AUDIO(state, media) {
    state.service_order_audios.push(media);
  },
  UPDATE_BUDGET(state, serviceOrderBudget) {
    if (!serviceOrderBudget || !state.budgets) return;

    const budgetIndex = state.budgets.findIndex((b) => b.id === serviceOrderBudget.id);

    if (budgetIndex === -1) {
      state.budgets.push(serviceOrderBudget);
    } else {
      state.budgets.splice(budgetIndex, 1, serviceOrderBudget);
    }
  },
  ADD_SECTION(state, sectionData) {
    state.service_order_photo_sections.push(sectionData);
  },
  ADD_SECTIONS(state, sections) {
    sections.forEach((section) => {
      const alreadyExists = state.service_order_photo_sections.some((existing) => existing.id === section.id);
      if (!alreadyExists) {
        state.service_order_photo_sections.push(section);
      }
    });
  },
  REMOVE_SECTION(state, sectionId) {
    const sectionIndex = state.service_order_photo_sections.findIndex(({ id }) => id === sectionId);
    if (sectionIndex === -1) return;
    state.service_order_photo_sections.splice(sectionIndex, 1);
  },
  RENAME_SECTION(state, { sectionId, description }) {
    const sectionIndex = state.service_order_photo_sections.findIndex(({ id }) => id === sectionId);
    if (sectionIndex === -1) return;
    state.service_order_photo_sections[sectionIndex].description = description;
  },
  CHECK_SECTION(state, { sectionId, isChecked }) {
    const sectionIndex = state.service_order_photo_sections.findIndex(({ id }) => id === sectionId);
    if (sectionIndex === -1) return;
    state.service_order_photo_sections[sectionIndex].isChecked = isChecked;
  },
  REMOVE_SECTION_MEDIA(state, mediaId) {
    const mediaIndex = state.service_order_photos.findIndex(({ id }) => id === mediaId);
    if (mediaIndex === -1) return;
    state.service_order_photos.splice(mediaIndex, 1);
  }
};

const actions = {
  updateServiceOrderDetails({ commit }, data) {
    commit('SET_UPDATED_SERVICE_ORDER', data);
  },
  resetState({ commit }) {
    commit('RESET_STATE');
  },
  setLoading({ commit }, status) {
    commit('SET_LOADING', status);
  },
  setVehicleLoading({ commit }, status) {
    commit('SET_VEHICLE_LOADING', status);
  },
  setMediaLoading({ commit }, status) {
    commit('SET_MEDIA_LOADING', status);
  },
  setDescriptionLoading({ commit }, status) {
    commit('SET_DESCRIPTION_LOADING', status);
  },
  getServiceOrder({ commit, dispatch }, serviceId) {
    dispatch('setLoading', true);
    api
      .get(`/service_order/${serviceId}/detail`)
      .then((response) => {
        commit('SET_SERVICE_ORDER', response.data);
        dispatch('setLoading', false);
        dispatch('calculateServiceOrderScore');
      })
      .catch(() => {
        dispatch('setLoading', false);
      });
  },
  createServiceOrder({ commit, dispatch }, typeId) {
    dispatch('setLoading', true);
    api
      .post('/service_order/create', {
        service_order_type_id: typeId
      })
      .then((response) => {
        commit('SET_SERVICE_ORDER', response.data);
        dispatch('setLoading', false);
      })
      .catch(() => {
        dispatch('setLoading', false);
        throw Error('Erro ao criar ordem de serviço');
      });
  },
  setClientByVehiclePlate({ dispatch }, data) {
    const clientVehicle = data;
    dispatch('saveClient', clientVehicle.vehicle.client);
    delete clientVehicle.vehicle.client;
    dispatch('saveVehicle', clientVehicle.vehicle);
  },
  saveClient({ commit, state }, client) {
    api
      .patch(`/service_order/${state.id}/update`, {
        client_id: client.id
      })
      .then((response) => {
        const { observation } = response.data;

        if (observation) {
          commit('SET_CLIENT_DESCRIPTION', observation);
        }

        commit('SET_CLIENT', client);
      });
  },
  saveVehicle({ commit, state }, vehicle) {
    api
      .patch(`/service_order/${state.id}/update`, {
        vehicle_id: vehicle.id
      })
      .then(() => {
        commit('SET_VEHICLE', vehicle);
      });
  },
  removeVehicle({ commit, state }) {
    api
      .patch(`/service_order/${state.id}/update`, {
        vehicle_id: null
      })
      .then(() => {
        commit('REMOVE_VEHICLE');
      });
  },
  saveServiceStatus({ commit }, status) {
    api.put(`/service_order/${state.id}/status`, { status: status.code }).then((r) => {
      commit('SET_SERVICE_STATUS', r.data);
    });
  },
  saveForecastDate({ commit }, date) {
    api.patch(`/service_order/${state.id}/update`, { forecast_date: date }).then(() => {
      commit('SET_FORECAST_DATE', date);
    });
  },
  saveClientDescription({ commit, dispatch }, description) {
    api.patch(`/service_order/${state.id}/update`, { description }).then(() => {
      commit('SET_CLIENT_DESCRIPTION', description);
      dispatch('calculateServiceOrderScore');
      dispatch('setDescriptionLoading', false);
    });
  },
  saveOrganizationObservation({ commit, dispatch }, observation) {
    api.patch(`/service_order/${state.id}/update`, { organization_observation: observation }).then(() => {
      commit('SET_ORGANIZATION_OBSERVATION', observation);
      dispatch('setDescriptionLoading', false);
    });
  },
  saveVehicleKilometer({ commit }, kilometer) {
    const vehicleKilometer = kilometer === '' ? null : kilometer;
    api.patch(`/service_order/${state.id}/update`, { vehicle_kilometer: vehicleKilometer }).then(() => {
      commit('SET_VEHICLE_KILOMETER', kilometer);
    });
  },
  saveResponsible({ commit, state, dispatch }, responsible) {
    api.post(`/service_order/${state.id}/responsible/create`, { user_id: responsible.id }).then(() => {
      const newResponsibles = JSON.parse(JSON.stringify(state.responsibles));
      newResponsibles.push(responsible);
      commit('SET_RESPONSIBLE', newResponsibles);
      dispatch('setLoading', false);
    });
  },
  removeResponsible({ commit, state, dispatch }, responsible) {
    api.delete(`/service_order/${state.id}/responsible/${responsible.id}/disable`).then(() => {
      let newResponsibles = JSON.parse(JSON.stringify(state.responsibles));
      newResponsibles = newResponsibles.filter((r) => r.id !== responsible.id);
      commit('SET_RESPONSIBLE', newResponsibles);
      dispatch('setLoading', false);
    });
  },
  updateChecklistItems({ commit, state, dispatch }, { checklistId, counters }) {
    const checklistIndex = state.service_order_checklists.findIndex((c) => c.checklist.id === checklistId);
    commit('UPDATE_CHECKLIST_ITEM', { checklistIndex, counters });
    dispatch('calculateServiceOrderScore');
  },
  updateChecklistWarning({ commit }, status) {
    commit('SET_CHECKLIST_WARNING', status);
  },
  updateSignature({ commit, dispatch }, signature) {
    commit('ADD_SIGNATURE', signature);
    dispatch('calculateServiceOrderScore');
  },
  removeSignature({ commit, dispatch }, signatureId) {
    commit('REMOVE_SIGNATURE', signatureId);
    dispatch('calculateServiceOrderScore');
  },
  createBring({ commit, state }, bring) {
    api.post(`/service_order/${state.id}/bring/create`, bring).then((r) => {
      commit('SET_SERVICE_ORDER_BRING', r.data);
    });
  },
  updateBring({ commit, state }, bring) {
    api.patch(`/service_order/${state.id}/bring/${bring.id}/update`, bring).then((r) => {
      commit('SET_SERVICE_ORDER_BRING', r.data);
    });
  },
  updateBringPhoto({ commit }, bring) {
    commit('SET_SERVICE_ORDER_BRING', bring);
  },
  addBudget({ commit }, data) {
    BudgetLogs.create({
      description: `Orçamento atrelado a Relatório de serviço #${data.service_order.number}`,
      user_id: data.user.id,
      budget_id: data.budget.id
    });

    const clientId = data.service_order.client ? data.service_order.client.id : null;

    BudgetService.update(data.budget.id, { service_order_id: data.service_order.id, client_id: clientId }).then(() => {
      commit('ADD_BUDGET', data.budget);
    });
  },
  checkWheelTorque({ commit, state }) {
    api.post(`/service_order_wheel_torque/${state.id}/check`).then((r) => {
      commit('SET_SERVICE_ORDER_WHEEL_TORQUE', r.data);
    });
  },
  uncheckWheelTorque({ commit, state }) {
    api.post(`/service_order_wheel_torque/${state.id}/uncheck`).then((r) => {
      commit('SET_SERVICE_ORDER_WHEEL_TORQUE', r.data || null);
    });
  },
  calculateServiceOrderScore({ commit, state }) {
    let score = 0;

    const classifications = [
      { emoji: '🤨', range: [0, 10], color: 'red darken-2' },
      { emoji: '🧐', range: [11, 50], color: 'red darken-2' },
      { emoji: '😃', range: [51, 75], color: 'primary' },
      { emoji: '😎', range: [76, 99], color: 'primary' }
    ];

    if (state.description && state.description.length > 0) {
      score += 10;
    }

    if (state.service_order_signatures && state.service_order_signatures.some((signature) => signature.signature_image)) {
      score += 20;
    }

    if (state.service_order_checklists && state.service_order_checklists.some((checklist) => checklist.checked_itens_ok > 0)) {
      score += 10;
    }

    if (state.service_order_photos) {
      const entryMedias = [
        'entry_medias_main',
        'entry_medias_front',
        'entry_medias_right',
        'entry_medias_rear',
        'entry_medias_panel',
        'entry_medias_left'
      ];

      const photosEntry = {};

      state.service_order_photos.forEach((photo) => {
        if (entryMedias.includes(photo.tag) && !photosEntry[photo.tag]) {
          photosEntry[photo.tag] = photo;
          score += 50 / entryMedias.length;
        }
      });
    }

    if (state.service_order_photos) {
      const leavingMedias = [
        'leaving_medias_main',
        'leaving_medias_front',
        'leaving_medias_right',
        'leaving_medias_rear',
        'leaving_medias_panel',
        'leaving_medias_left'
      ];

      const photosLeaving = {};

      state.service_order_photos.forEach((photo) => {
        if (leavingMedias.includes(photo.tag) && !photosLeaving[photo.tag]) {
          photosLeaving[photo.tag] = photo;
          score += 10 / leavingMedias.length;
        }
      });
    }

    let serviceOrderScore = null;

    if (score === 0) {
      serviceOrderScore = { emoji: '😃', range: [0, 0], color: '#c9c9c9', score: 0 };
      commit('SET_SCORE', serviceOrderScore);
    } else if (score.toFixed(0) === '100') {
      serviceOrderScore = { emoji: '👏', range: [100, 100], color: '#FFD600', score: 100 };
      commit('SET_SCORE', serviceOrderScore);
    } else {
      serviceOrderScore = classifications.find((c) => score >= c.range[0] && score <= c.range[1]);
      commit('SET_SCORE', { ...serviceOrderScore, score: score % 1 !== 0 ? score.toFixed(2) : score });
    }
  },
  deleteMedia({ commit, state, dispatch }, mediaId) {
    if (!mediaId || mediaId === null || mediaId === undefined) {
      console.warn('Tentativa de deletar mídia com ID inválido:', mediaId);
      return Promise.reject(new Error('ID de mídia inválido'));
    }

    return api
      .delete(`/service_order/${state.id}/photo/${mediaId}/disable`)
      .then(() => {
        commit('REMOVE_SERVICE_ORDER_PHOTO', mediaId);
        dispatch('calculateServiceOrderScore');
      })
      .catch((error) => {
        console.error('Erro ao deletar mídia:', error);
        throw error;
      });
  },
  addMedia({ commit, dispatch }, media) {
    commit('ADD_SERVICE_ORDER_PHOTO', media);
    dispatch('calculateServiceOrderScore');
  },
  addAudio({ commit }, media) {
    commit('ADD_SERVICE_ORDER_AUDIO', media);
  },
  removeAudio({ commit }, mediaId) {
    api.delete(`/service_order/${state.id}/audio/${mediaId}/disable`).then(() => {
      commit('REMOVE_SERVICE_ORDER_AUDIO', mediaId);
    });
  },
  async addSection({ commit, state }, sectionData) {
    const { data } = await api.post(`/v2/service_order/photo_section/${state.id}/create`, sectionData);
    const order = sectionData.order ?? sectionData.sort_order ?? null;
    commit('ADD_SECTION', {
      ...data.serviceOrderPhotoSection,
      order,
      sort_order: order
    });
  },
  async bulkCreateSections({ commit, state }) {
    const { data } = await api.post(`/v2/service_order/photo_section/${state.id}/bulk_create`, {});
    const sections = (data?.serviceOrderPhotoSections ?? []).map((section) => {
      const order = section.sort_order ?? section.order ?? null;
      return {
        ...section,
        order,
        sort_order: order
      };
    });
    commit('ADD_SECTIONS', sections);
    return sections;
  },
  async removeSection({ commit, state }, sectionId) {
    await api.patch(`/v2/service_order/${state.id}/photo_section/${sectionId}/disable`);
    commit('REMOVE_SECTION', sectionId);
  },
  async renameSection({ commit, state }, { sectionId, description }) {
    await api.patch(`/v2/service_order/${state.id}/photo_section/${sectionId}/update`, { description });
    commit('RENAME_SECTION', { sectionId, description });
  },
  async checkSection({ commit, state }, { sectionId, isChecked }) {
    await api.post(`/v2/service_order/${state.id}/photo_section/${sectionId}/check/change`, {
      checked: isChecked
    });
    commit('CHECK_SECTION', { sectionId, isChecked });
  },
  async removeSectionMedia({ commit, state }, mediaId) {
    await api.delete(`/service_order/${state.id}/photo/${mediaId}/disable`);
    commit('REMOVE_SECTION_MEDIA', mediaId);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
